import { Form } from "antd";
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useDebouncedCallback } from "use-debounce";
import { useFormContext } from "../../../../context/FormContext/FormContext";
import { handleChangedRelatedField, handleGridTechname, renderDevInfo } from "../../GeneralScripts";
import PropTypes from "prop-types";
import "./RadioField.less";
import { RadioGroup, Radio } from "../../../BP2Components";
import { getAllFieldsWithAlerts } from "../../../../util/Scripts";

const RadioField = ({
   isRequired,
   element,
   form,
   isVisible,
   disabled,
   formId,
   insideGrid = false,
   rowDataId,
}) => {
   const { formData, changeFieldPendingStatus, setFieldsInfo, fieldEnumMap } = useFormContext();
   const intl = useIntl();
   const { getFieldDecorator } = form;
   const [options, setOptions] = useState([]);

   const allFieldsWithAlerts = getAllFieldsWithAlerts(formData?.forms_data?.tab?.[0]?.elements);

   const handleCheckBoxChange = useDebouncedCallback(() => {
      handleChangedRelatedField(
         element,
         form,
         setFieldsInfo,
         allFieldsWithAlerts,
         formId,
         intl,
         formData._formKey,
         rowDataId,
         changeFieldPendingStatus,
         fieldEnumMap,
      );
   }, 1000);

   useEffect(() => {
      let elementOptions = [];
      if (element && element.sortedOptions) {
         for (const property in element.sortedOptions) {
            const sortedElement = element.sortedOptions[property];
            const sortedElementKey = Object.keys(sortedElement)[0];
            elementOptions.push({
               label: sortedElement[sortedElementKey],
               value: sortedElementKey,
            });
         }
      }
      setOptions(elementOptions);
   }, []);
   const translatedLabel = element.label;
   return (
      <Form.Item
         key={element.tech_name}
         label={!insideGrid && translatedLabel}
         className={`${element?.type}-field`}
         style={{
            display: isVisible(element) ? "" : "none",
            gridArea: handleGridTechname(element.tech_name),
         }}
      >
         {getFieldDecorator(element.tech_name, {
            rules: [
               {
                  required: isRequired(element),
                  message: intl.formatMessage({ id: "field.required" }),
               },
            ],
            initialValue: element.value,
         })(
            <RadioGroup
               onChange={handleCheckBoxChange}
               disabled={disabled}
               className={`field_${element.tech_name}`}
            >
               {options.map((option) => (
                  <Radio
                     value={option.value}
                     key={option.value}
                     id={option.value}
                     style={{ display: "block", lineHeight: "30px" }}
                  >
                     {option.label}
                  </Radio>
               ))}
            </RadioGroup>,
         )}
         {renderDevInfo(element)}
      </Form.Item>
   );
};

RadioField.propTypes = {
   element: PropTypes.object.isRequired,
   disabled: PropTypes.bool,
   isVisible: PropTypes.func,
   form: PropTypes.any,
   formId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default RadioField;
